// Car → Type mapping
export const carTypeMap = {
 // Hatchbacks
  "Ford - Figo": "Hatchback",
  "Ford - Freestyle": "Hatchback",
  "Ford - Edge": "Hatchback",
  "Skoda - Fabia": "Hatchback",
  "Volkas wagen - Gulf GTI": "Hatchback",
  "Volkas wagen - Polo": "Hatchback",
  "Volkas wagen - Ameo": "Hatchback",
  "Volkas wagen - Betle": "Hatchback",
  "MG Hector - Commit": "Hatchback",
  "MG Hector - Astor": "Hatchback",
  "Renult - KWID": "Hatchback",
  "Renult - Clio": "Hatchback",
  "Nissan - Micra": "Hatchback",
  "Benz - A class Limo": "Hatchback",
  "Honda - Brio": "Hatchback",
  "Honda - Jazz": "Hatchback",
  "Tata - Tata altroz": "Hatchback",
  "Tata - Punch": "Hatchback",
  "Tata - Indica": "Hatchback",
  "Tata - Nano": "Hatchback",
  "Tata - Tiago": "Hatchback",
  "Tata - Tigor": "Hatchback",
  "Maruthi Suzuki - Swift": "Hatchback",
  "Maruthi Suzuki - Baleno": "Hatchback",
  "Maruthi Suzuki - Dzire": "Hatchback",
  "Maruthi Suzuki - Alto": "Hatchback",
  "Maruthi Suzuki - Wagonr": "Hatchback",
  "Maruthi Suzuki - Ignis": "Hatchback",
  "Maruthi Suzuki - Celerio": "Hatchback",
  "Maruthi Suzuki - S presso": "Hatchback",
  "Maruthi Suzuki - Fronx": "Hatchback",
  "Mahendra - KUV100": "Hatchback",
  "Hyundai - Aura": "Hatchback",
  "Hyundai - Grand i10": "Hatchback",
  "Hyundai - Grand i20": "Hatchback",
  "Hyundai - Santro": "Hatchback",
  "Hyundai - Kona": "Hatchback",
  "Toyota - Glaza": "Hatchback",
  "Toyota - Liva": "Hatchback",


  // Sedans
  "Ford - Aspire": "Sedan",
  "Ford - Fiesta": "Sedan",
  "Ford - Fusion": "Sedan",
  "Ford - Taurus": "Sedan",
  "Skoda - Slavia": "Sedan",
  "Skoda - Octavia": "Sedan",
  "Skoda - Superb": "Sedan",
  "Skoda - Rapid": "Sedan",
  "Skoda - Laura": "Sedan",
  "Volkas wagen - Virtus": "Sedan",
  "Volkas wagen - Passat": "Sedan",
  "Volkas wagen - Ameo": "Sedan",
  "Volkas wagen - Jetta": "Sedan",
  "Volkas wagen - Vento": "Sedan",
  "BYD - Seal": "Sedan",
  "Audi - Audi Ay": "Sedan",
  "Audi - Audi A6": "Sedan",
  "Audi - Audi A8L": "Sedan",
  "Audi - Audi S5": "Sedan",
  "Audi - Audi RS5": "Sedan",
  "Audi - Audi RSQ8": "Sedan",
  "Renult - Scala": "Sedan",
  "Renult - Logan": "Sedan",
  "Nissan - Sunny": "Sedan",
  "BMW - Z4": "Sedan",
  "BMW - I4": "Sedan",
  "BMW - 2 Series": "Sedan",
  "BMW - 3 Series": "Sedan",
  "BMW - 5 Series": "Sedan",
  "BMW - 6 Series": "Sedan",
  "BMW - M4": "Sedan",
  "BMW - I5": "Sedan",
  "BMW - M2": "Sedan",
  "Benz - C-class": "Sedan",
  "Benz - CLA": "Sedan",
  "Benz - GLV": "Sedan",
  "Benz - E-class": "Sedan",
  "Benz - S-class": "Sedan",
  "Benz - EQS": "Sedan",
  "Benz - Coupe": "Sedan",
  "Benz - SL": "Sedan",
  "Honda - Amaze": "Sedan",
  "Honda - Honda city": "Sedan",
  "Honda - Civic": "Sedan",
  "Honda - Accord": "Sedan",
  "Maruthi Suzuki - Ciaz": "Sedan",
  "Mahendra - Verito": "Sedan",
  "Hyundai - Verna": "Sedan",
  "Hyundai - Elantra": "Sedan",
  "Hyundai - Accent": "Sedan",
  "Toyota - Camroi": "Sedan",
  "Toyota - Corolla": "Sedan",
  "Toyota - ETIOS": "Sedan",
  "Toyota - Yaris": "Sedan",

  // SUVs
  "Ford - Eco sport": "C_SUV",
  "Ford - Endeavour": "SUV",
  "Skoda - Kulag": "C_SUV",
  "Skoda - Kushaq": "C_SUV",
  "Skoda - Elroq": "C_SUV",
  "Kia - Seltos": "C_SUV",
  "Kia - EV6": "SUV",
  "Kia - Sonnat": "C_SUV",
  "Kia - Carens": "SUV",
  "Kia - Carnival": "Luxury_SUV",
  "Kia - Syros": "C_SUV",
  "Kia - EV9": "SUV",
  "Volkas wagen - Taigun": "C_SUV",
  "Volkas wagen - Tiguan": "C_SUV",
  "Volkas wagen - Troc": "C_SUV",
  "Volkas wagen - Tiguan": "C_SUV",
  "Volkas wagen - Tcross": "SUV",
  "MG Hector - Windsor": "C_SUV",
  "MG Hector - Hecto": "SUV",
  "MG Hector - Gloster": "SUV",
  "MG Hector - ZS-EV": "C_SUV",
  "BYD - ATTO 3": "SUV",
  "BYD - Emax7": "C_SUV",
  "Audi - Audi Q3": "SUV",
  "Audi - Audi Q5": "SUV",
  "Audi - Audi Q7": "SUV",
  "Audi - Audi Q8": "SUV",
  "Audi - Audi Q3": "SUV",
  "Range Rover - range Rover": "UltraLuxury_SUV",
  "Range Rover - Velar": "UltraLuxury_SUV",
  "Range Rover - Sport": "UltraLuxury_SUV",
  "Range Rover - Evoque": "UltraLuxury_SUV",
  "Range Rover - Discover Sport": "UltraLuxury_SUV",
  "Range Rover - Auto Biography": "UltraLuxury_SUV",
  "Land Rover - Land Rover": "UltraPremium_SUV",
  "Land Rover - Discover Sport": "UltraLuxury_SUV",
  "Land Rover - Defender": "UltraLuxury_SUV",
  "Land Rover - Discovery": "UltraLuxury_SUV",
  "Renult - Duster": "C_SUV",
  "Renult - Triber": "C_SUV",
  "Renult - Kiger": "C_SUV",
  "Nissan - Magnet": "C_SUV",
  "Nissan - Terrano": "C_SUV", 
  "BMW - X1": "SUV",
  "BMW - X7": "SUV",
  "BMW - X5": "SUV",
  "BMW - XM": "SUV",
  "BMW - 7series": "SUV",
  "BMW - IX1": "SUV",
  "BMW - X3": "SUV",
  "BMW - I7": "SUV",
  "BMW - IX": "SUV",
  "Benz - GLA": "SUV",
  "Benz - GLC": "C_SUV",
  "Benz - GLE": "SUV",
  "Benz - GLS": "SUV",
  "Benz - G-class": "SUV",
  "Benz - AMG a45s": "C_SUV",
  "Benz - G-vegan": "SUV",
  "Benz - R-class": "SUV",
  "Honda - WRV": "C_SUV",
  "Honda - BR-V": "C_SUV",
  "Honda - CR-V": "SUV",
  "Honda - Elevate": "C_SUV",
  "Honda - Pilot": "SUV",
  "Tata - Harrier": "SUV",
  "Tata - Nexon": "C_SUV",
  "Tata - Curvv": "C_SUV",
  "Tata - Saffari": "SUV",
  "Tata - Sierra": "SUV",
  "Tata - Sumo": "SUV",
  "Maruthi suzuki - Brazza": "C_SUV",
  "Maruthi suzuki - Ertiga": "SUV",
  "Maruthi suzuki - S-cross": "C_SUV",
  "Maruthi suzuki - XL6": "SUV",
  "Maruthi suzuki - Grand vitara": "C_SUV",
  "Maruthi suzuki - Jimmy": "SUV",
  "Maruthi suzuki - EECO": "SUV",
  "Maruthi suzuki - Invicto": "SUV",
  "Mahendra - Thar Roxx": "SUV",
  "Mahendra - Thar": "SUV",
  "Mahendra - XUV 3xo": "C_SUV",
  "Mahendra - Scorpio": "SUV",
  "Mahendra - XUV 700": "SUV",
  "Mahendra - Bolero": "SUV",
  "Mahendra - XUV 400": "C_SUV",
  "Mahendra - Mahendra BE6": "SUV",
  "Mahendra - XEV 9E": "SUV",
  "Mahendra - Marrazo": "SUV",
  "Mahendra - XYLO": "SUV",
  "Mahendra - Alturas": "SUV",
  "Hyundai - Exter": "C_SUV",
  "Hyundai - Venue": "C_SUV",
  "Hyundai - Creta": "C_SUV",
  "Hyundai - Alcazar": "SUV",
  "Hyundai - Fusion": "SUV",
  "Hyundai - Ioniq 5": "SUV",
  "Toyota - Urban Cruiser": "C_SUV",
  "Toyota - Innova crysta/Hycross": "SUV",
  "Toyota - Hilux": "SUV",
  "Toyota - Fortuner": "SUV",
  "Toyota - Prado": "SUV",

  //Ultraluxury
  "Nissan - GTR": "Ultraluxury",
  "Benz - V-class": "Ultraluxury",
  "Toyota - Land cruiser": "Ultraluxury",
  "Toyota - Vellfire": "Ultraluxury",
};

// Base price per type
export const planPricing = {
  Hatchback: 1799,
  Sedan: 1999,
  SUV: 2299,
  C_SUV: 1999,
  Luxury_SUV:2299,
UltraLuxury_SUV:2299,
UltraPremium_SUV:2299,

  Ultraluxury:2999
};

// Multiply by duration
export const durationMultipliers = {
  "1": 1,     // 1 month
  "3": 3,     // 3 months
  "6": 6,     // 6 months
  "12": 12,   // 12 months
};
